"use strict";

var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.StyledSpinWrap = exports.StyledSpinText = exports.StyledSpinSpinning = exports.StyledSpinLoaderPath = exports.StyledSpinLoader = exports.StyledSpinDot = exports.StyledSpinContainer = void 0;
var _ykbStyledComponents = _interopRequireWildcard(require("../ykb-styled-components"));
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
var StyledSpinWrap = exports.StyledSpinWrap = _ykbStyledComponents.default.div.withConfig({
  componentId: "ykb-ui__sc-139vjeh-0"
})([""]);
var StyledSpinDot = exports.StyledSpinDot = _ykbStyledComponents.default.span.withConfig({
  componentId: "ykb-ui__sc-139vjeh-1"
})([""]);
var StyledSpinLoader = exports.StyledSpinLoader = _ykbStyledComponents.default.svg.withConfig({
  componentId: "ykb-ui__sc-139vjeh-2"
})([""]);
var StyledSpinLoaderPath = exports.StyledSpinLoaderPath = _ykbStyledComponents.default.circle.withConfig({
  componentId: "ykb-ui__sc-139vjeh-3"
})([""]);
var StyledSpinText = exports.StyledSpinText = _ykbStyledComponents.default.span.withConfig({
  componentId: "ykb-ui__sc-139vjeh-4"
})([""]);
var StyledSpinContainer = exports.StyledSpinContainer = _ykbStyledComponents.default.div.withConfig({
  componentId: "ykb-ui__sc-139vjeh-5"
})([""]);
var StyledSpinSpinning = exports.StyledSpinSpinning = _ykbStyledComponents.default.div.withConfig({
  componentId: "ykb-ui__sc-139vjeh-6"
})([""]);
var spinRotate = (0, _ykbStyledComponents.keyframes)(["100%{-webkit-transform:rotate(360deg);transform:rotate(360deg);}"]);
var spinDash = (0, _ykbStyledComponents.keyframes)(["0%{stroke-dasharray:1,200;stroke-dashoffset:0;}50%{stroke-dasharray:89,200;stroke-dashoffset:-35;}100%{stroke-dasharray:89,200;stroke-dashoffset:-124;}"]);
var StyledSpin = _ykbStyledComponents.default.div.withConfig({
  componentId: "ykb-ui__sc-139vjeh-7"
})(["display:inline-block;position:static;opacity:1;width:100%;height:100%;vertical-align:middle;", " ", "{top:50%;left:50%;transform:translate(-50%,-50%);position:absolute;text-align:center;margin-top:10px;", "}", "{position:relative;z-index:10;", "{-webkit-animation:", " 2s linear infinite;animation:", " 2s linear infinite;height:100%;width:", ";height:", ";display:block;margin:0 auto;}", "{stroke-dasharray:150,200;stroke-dashoffset:-10;-webkit-animation:", " 1.5s ease-in-out infinite;animation:", " 1.5s ease-in-out infinite;stroke-linecap:round;stroke:", ";}}", "{display:block;padding-top:", ";color:", ";font-size:", ";font-weight:", ";}", "{", "}"], function (props) {
  return props.$nested && (0, _ykbStyledComponents.css)(["position:relative;height:auto;"]);
}, StyledSpinWrap, function (props) {
  return props.$resetMargin && (0, _ykbStyledComponents.css)(["margin-top:0px;"]);
}, StyledSpinDot, StyledSpinLoader, spinRotate, spinRotate, function (props) {
  return props.theme.spin.width + 'px';
}, function (props) {
  return props.theme.spin.width + 'px';
}, StyledSpinLoaderPath, spinDash, spinDash, function (props) {
  return props.theme.spin.color;
}, StyledSpinText, function (props) {
  return props.theme.spin.gapBetween;
}, function (props) {
  return props.theme.spin.color;
}, function (props) {
  return props.theme.spin.fontSize;
}, function (props) {
  return props.theme.spin.fontWeight;
}, StyledSpinContainer, function (props) {
  return props.spinning && (0, _ykbStyledComponents.css)(["overflow:hidden;opacity:", ";filter:blur(0.8px);user-select:none;z-index:9;pointer-events:none;"], function (props) {
    return props.theme.spin.bgOpacity;
  });
});
var _default = exports.default = StyledSpin;